import { MaskHelper } from './../helpers/mask';
import { AppService } from './../app.service';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ReembolsoModel } from '../components/reembolso/reembolso.model';

@Injectable()
export class ReembolsoService extends AppService<any> {

  constructor(http: HttpClient) {
    super(http);
  }

  async solicitarReembolso(reembolso: ReembolsoModel, historicoAssociacaoId) {
    const result = await this.postAsync(`Reembolso/${historicoAssociacaoId}`, reembolso);
    return result;
  }

}



// WEBPACK FOOTER //
// /usr/src/app/src/app/services/reembolso.service.ts